import { useDispatch, useSelector } from 'react-redux'
import { fixAdd } from '../../../helpers/math'
import {
  changeOwnershipTypeActiveIndex,
  filterTable,
  selectOwnershipStructure,
  selectOwnershipTypeActiveIndex,
  selectOwnershipTypes,
} from '../store/slice'
import { OTHER_ID, colorChart } from './constants'
import { PieChartComponent } from './pieChartComponent'

const sum = (data, ownershipTypeId) => {
  let sum = 0

  Object.values(data).forEach((item) => {
    if (item.ownershipTypeId === ownershipTypeId) {
      sum = fixAdd(sum, item.percentage)
    }
  })

  return sum
}

const getData = (data, ownershipTypes) => {
  const formatItems = ownershipTypes.map((item) => {
    return {
      ownershipTypeId: item.ownershipTypeId,
      isI18n: false,
      name: item.ownershipTypeName,
      value: sum(data, item.ownershipTypeId),
    }
  })

  const itemsWithColor = formatItems.map((item, index) => {
    return {
      ...item,
      index,
      color: colorChart[index],
      value: item.value <= 1 ? item.value : 0,
    }
  })

  const sumPercentage = itemsWithColor.reduce(
    (sum, item) => sum + item.value,
    0,
  )

  if (sumPercentage >= 1) {
    return itemsWithColor
  }

  return [
    ...itemsWithColor,
    {
      index: itemsWithColor.length,
      ownershipTypeId: OTHER_ID,
      isI18n: true,
      name: 'companyAnalysis.ownershipAndGroup.OTHERS',
      value: 1 - sumPercentage,
      color: colorChart[itemsWithColor.length],
    },
  ]
}

export const OwnershipType = () => {
  const dispatch = useDispatch()

  const activeIndex = useSelector(selectOwnershipTypeActiveIndex)
  const ownershipTypes = useSelector(selectOwnershipTypes)
  const data = useSelector(selectOwnershipStructure)
  const fiveItemsWithOther = getData(data, ownershipTypes)

  const filterType = ({ index, ownershipTypeId }) => {
    if (activeIndex !== index) {
      dispatch(changeOwnershipTypeActiveIndex(index))
      dispatch(
        filterTable({
          ownershipTypeId: {
            key: 'ownershipTypeId',
            ownershipTypeId,
            exceptIds: fiveItemsWithOther.map((item) => item.ownershipTypeId),
          },
        }),
      )
    } else {
      dispatch(changeOwnershipTypeActiveIndex())
      dispatch(
        filterTable({
          ownershipTypeId: {},
        }),
      )
    }
  }

  return (
    <PieChartComponent
      onPieClick={filterType}
      data={fiveItemsWithOther}
      title="companyAnalysis.ownershipAndGroup.OWNERSHIP_TYPES"
      activeIndex={activeIndex}
    />
  )
}
